import { PiiConsentTexts } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints РґР»СЏ admin-backend /pii-consent-texts/*.
 *
 * Authz: super_admin only. Р’СЃРµ РѕС‚РІРµС‚С‹ РїР°СЂСЃСЏС‚СЃСЏ С‡РµСЂРµР· Zod вЂ”
 * drift backendв†”frontend РїР°РґР°РµС‚ РіСЂРѕРјРєРѕ.
 */
export const piiConsentTextsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listAdminPiiConsentTexts: build.query<
            PiiConsentTexts.GetAdminPiiConsentTextsResponse,
            void
        >({
            query: () => ({
                url: '/pii-consent-texts',
                method: 'GET'
            }),
            transformResponse: (
                raw: unknown
            ): PiiConsentTexts.GetAdminPiiConsentTextsResponse =>
                parseWithSchema(
                    PiiConsentTexts.GetAdminPiiConsentTextsResponseSchema,
                    raw
                ),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((t) => ({
                            type: 'PiiConsentText' as const,
                            id: t.version
                        })),
                        { type: 'PiiConsentText' as const, id: 'LIST' }
                    ]
                    : [{ type: 'PiiConsentText' as const, id: 'LIST' }]
        }),

        createAdminPiiConsentText: build.mutation<
            PiiConsentTexts.CreateAdminPiiConsentTextResponse,
            PiiConsentTexts.CreateAdminPiiConsentTextRequest
        >({
            query: (body) => ({
                url: '/pii-consent-texts',
                method: 'POST',
                body
            }),
            transformResponse: (
                raw: unknown
            ): PiiConsentTexts.CreateAdminPiiConsentTextResponse =>
                parseWithSchema(
                    PiiConsentTexts.CreateAdminPiiConsentTextResponseSchema,
                    raw
                ),
            invalidatesTags: [{ type: 'PiiConsentText', id: 'LIST' }]
        })
    })
});

export const {
    useListAdminPiiConsentTextsQuery,
    useCreateAdminPiiConsentTextMutation
} = piiConsentTextsApi;
